import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {SharedVarService} from '../shared-service.service';
import {AppComponent} from '../../app.component';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {QueryService} from '../../Services/query.service';
import {ContainerView} from '../../Interfaces/ContainerView';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {Sealink} from '../../Interfaces/Sealink';
import {User} from '../../Interfaces/User';
import {Subscription} from 'rxjs';
import {EmptyReceiveSchedule} from '../../Interfaces/EmptyReceiveSchedule';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';

@Component({
  selector: 'app-vessel-schedule',
  templateUrl: './vessel-schedule.component.html',
  styleUrls: ['./vessel-schedule.component.css']
})
export class VesselScheduleComponent implements OnInit {
  private clientRequest: ClientRequest;
  public  myUser: User;
  subscription: Subscription;
  private vrs: EmptyReceiveSchedule [] = [];
  quickViewData: MatTableDataSource<EmptyReceiveSchedule>;
  search1: UntypedFormControl;
  public qvColumns: string[];
  phoneApp: boolean = false;
  public dateOut: Date;
  @ViewChild(MatPaginator) set content2(pag: MatPaginator) {
    if (this.quickViewData != undefined) {
      this.quickViewData.paginator = pag;
    }
  }

  constructor(fb: UntypedFormBuilder, private router: Router, private service: SharedVarService, public myApp: AppComponent, private renderer: Renderer2, private  globalEventsManager: GlobalEventsManager, private  queryService: QueryService) {
    this.qvColumns = ["vessel_description", "auto_on_off"];


    this.myUser = this.myApp.user;
/*
        this.myUser = {} as User;
        this.myUser.active = "Y"
        this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
        this.myUser.address_2 = null
        //this.myUser.company_code ="EGN"
        this.myUser.company_code = "M0995"
        this.myUser.company_name = "MAHER TERMINALS, LLC"
        this.myUser.city = "HOUSTON"
        this.myUser.email_address = "cmilller@maherterminals.com"
        this.myUser.fax_number = null
        this.myUser.first_name = "Csp Craig"
        this.myUser.last_name = "Miller"
        this.myUser.maherError = null
        this.myUser.old_password = null
        this.myUser.password = ""
        this.myUser.phone_number = null
        this.myUser.company_scac = null
        this.myUser.state = "TX"
        this.myUser.userMenuReportItemsView = null
        this.myUser.user_gkey = "8237887"
       this.myUser.role = "AGENT"
        //this.myUser.role= "LINEOP"
        // this.myUser.role= "HAULIER"
        this.myUser.username = "CDOUG"
        this.myUser.zip = "07201"
        this.myUser.canSeeAllData = "1";



 */


      }


      ngOnInit() {
        this.search1 = new UntypedFormControl();
        this.getSchedule();

        if (window.innerWidth <= 750){
          this.phoneApp = true;
        }
      }

      applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        this.quickViewData.filter = filterValue;
      }

      getSchedule(){

        this.clientRequest = null;
        this.clientRequest = {} as ClientRequest;
        this.clientRequest.user = this.myUser;
        this.clientRequest.requestData = [];
        var lhsUserObs$ = this.queryService.getVesselReceiveSchedule(this.clientRequest);
        this.subscription = lhsUserObs$.subscribe(
          (cus) => {
            this.vrs = cus;
          },
          error => {
            if (error.status == "401") {
              this.globalEventsManager.showLogin.emit(true);

              this.router.navigate(["login"]);
            }
          },
          () => {
            this.search1.reset();
            this.dateOut = new Date();
            for (var items of this.vrs){
              if (items.text_message!=null && items.text_message!=""){
                items.text_message = items.text_message.trim();
                items.text_message = "- "+items.text_message

              }
            }
            this.quickViewData = new MatTableDataSource<EmptyReceiveSchedule>(this.vrs);
        /*    this.quickViewData.sortingDataAccessor = (item, property) => {
              switch (property) {
                case 'driver_expiration': return new Date(item.driver_expiration);
                case 'driver_company_expiration': return new Date(item.driver_company_expiration);
                default: return item[property];
              }
            };
    */
      });
  }


}
